import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { terminalGroupsQueryOptions } from '../queries/terminalGroups';
import { hasAliveTerminalGroup } from '../utils/terminalGroupSync';
import { MENU_MOCK_MODE } from '../data/mockMenu';

export function TerminalOfflineBanner() {
  const { data: terminalGroups = [], isFetched } = useQuery({
    ...terminalGroupsQueryOptions(),
    enabled: !MENU_MOCK_MODE,
  });
  if (MENU_MOCK_MODE || !isFetched || hasAliveTerminalGroup(terminalGroups)) return null;
  return (
    <div
      className="px-4 py-2.5 text-center text-xs font-medium leading-snug"
      style={{ background: '#2a2a2a', color: 'rgba(255,255,255,0.88)' }}
    >
      Ресторан временно не принимает заказы. Попробуйте позже.
    </div>
  );
}
